var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "-37.13 -37.13 445.58 445.58",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.13,
    y: -37.13,
    width: 445.58,
    height: 445.58,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.681,365.095l199.667,6.224c0,0-2.989-3.865-7.719-9.984c0,0,14.597-195.865-5.757-273.909 c-16.359-62.694-71.044-80.052-91.945-84.455c-0.327-0.239-0.537-0.385-0.537-0.385c-1.354-0.199-2.628-0.298-3.97-0.467 c-2.383-0.403-3.749-0.537-3.749-0.537l0.035,0.087C146.774-6.558,97.952,17.596,80.208,31.369 c-31.75,26.379-22.794,76.083-16.861,91.368c0.157,0.596,0.286,1.22,0.432,1.828c-3.34,0.683-8.565,0.683-12.751-5.237 c-1.758,8.513,8.121,9.768,13.504,9.855c0.583,5.664-0.134,11.8-3.982,17.597c-8.098,12.162-17.136,17.708-20.056,25.865 c-4.146,11.373,17.685,13.347,17.685,13.347l0.047,4.32c0,0-6.995,6.773-5.512,12.074c1.985,7.089,16.05,4.577,16.05,4.577 s-13.505,4.986-12.868,11.561c0.636,6.586,6.276,9.436,6.276,9.436s-13.078,25.689,6.16,31.364 c19.226,5.651,58.269-17.819,63.348,9.622c4.916,18.917,26.822,65.392,19.227,74.08 C143.318,351.737,131.681,365.095,131.681,365.095z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel1);
export default __webpack_public_path__ + "static/media/model1.56afc374758234d00f45913a8ed0207e.svg";
export { ForwardRef as ReactComponent };